import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import AboutTwo from '../../components/about-two'
import ClientTwo from '../../components/client-two'
import BlogOne from '../../components/blog-one'
import About from '../../components/about'
import TeamTwo from '../../components/team-two'
import Shape from '../../components/shape'
import Footer from '../../components/footer'

import cta from '../../assets/images/cta.jpg'
import bg1 from '../../assets/images/finance/bg1.jpg'
import bg2 from '../../assets/images/finance/bg2.jpg'
import bg3 from '../../assets/images/finance/bg3.jpg'

import { financefeature } from '../../data/data'

const images = [bg1, bg2, bg3];

export default function IndexFinance() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
        if(currentIndex === images.length - 1) {
            setCurrentIndex(0);
        } 
        else {
             setCurrentIndex(currentIndex + 1);
        }
    }, 5000)
    
    return () => clearInterval(intervalId);
}, [])

  return (
    <>
    <Navbar navLight={true}/> 
    <section className="bg-home zoom-image d-flex align-items-center">
      <div className="bg-overlay image-wrap" id="home" style={{backgroundImage:`url(${images[currentIndex]})`, backgroundSize:'cover', backgroundRepeat:'no-repeat', backgroundPosition:'center'}}></div>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row justify-content-center mt-5">
              <div className="col-12">
                  <div className="title-heading text-center">
                      <h4 className="display-4 fw-bold text-white title-dark">Raise, Hold, Spend And Send <br/> - All in one place</h4>
                      <p className="para-desc mx-auto text-white-50">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="#" className="btn btn-primary m-1">Contact us</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne textLight={true}/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section" id="features">
      <div className="container">
          <div className="row">
            {financefeature.map((item,index)=>{
              return(
                <div className="col-md-4 col-12 mt-4 pt-2 mt-sm-0 pt-sm-0" key={index}>
                    <div className="features text-center px-lg-4">
                        <img src={item.image} className="avatar avatar-small" alt=""/>
                        <div className="content">
                            <h4 className="title mt-4">{item.title}</h4>
                            <p className="text-muted mb-0">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>
      <div className="container mt-100 mt-60">
        <AboutTwo/>
      </div>
    </section>

    <section style={{backgroundImage:`url(${cta})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-primary shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row mb-4 pb-2 mt-5 pt-4">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Our Dream Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamTwo/>
      </div>
      <div className="container mt-100 mt-60">
          <About/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
